'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
var $p;
/** @constructor */
function $c_Lpresto_types$$anon$190() {
  this.c1V = null;
  this.c1T = null;
  this.c1U = false;
  this.c1R = null;
  this.c1S = false;
  this.c1W = false;
  this.c1X = false;
  this.c1V = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_derivation_Configuration$().u;
}
export { $c_Lpresto_types$$anon$190 as $c_Lpresto_types$$anon$190 };
$p = $c_Lpresto_types$$anon$190.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_types$$anon$190;
/** @constructor */
function $h_Lpresto_types$$anon$190() {
}
export { $h_Lpresto_types$$anon$190 as $h_Lpresto_types$$anon$190 };
$h_Lpresto_types$$anon$190.prototype = $p;
$p.a1 = (function(a) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_Encoder$AsObject__apply__O__Lio_circe_Json(this, a);
});
$p.ac = (function() {
  return this.c1V;
});
$p.t = (function() {
  if ((!this.c1U)) {
    this.c1T = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("hour", new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("minute", $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$()));
    this.c1U = true;
  }
  return this.c1T;
});
$p.ad = (function() {
  if ((!this.c1S)) {
    this.c1R = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Encoder$().rg, new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Encoder$().rg, $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$()));
    this.c1S = true;
  }
  return this.c1R;
});
$p.v = (function() {
  if ((!this.c1X)) {
    this.c1W = false;
    this.c1X = true;
  }
  return this.c1W;
});
$p.aco = (function(a) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredEncoder__encodeProduct__O__Lio_circe_JsonObject(this, a);
});
$p.ab = (function(a) {
  return this.aco(a);
});
var $d_Lpresto_types$$anon$190 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_types$$anon$190, "presto.types$$anon$190", ({
  Yw: 1,
  a: 1,
  j: 1,
  n: 1,
  o: 1,
  p: 1,
  d: 1
}));
export { $d_Lpresto_types$$anon$190 as $d_Lpresto_types$$anon$190 };
//# sourceMappingURL=presto.types$$anon$190.js.map
